import PropTypes from 'prop-types';

// The prominent lead tile of the KPI strip — "Diligencias activas" with a big
// display number, an inline meta note, a delta line, and a click-through hint.
export function KpiHero({ label, value, meta, delta, hint, onClick }) {
  return (
    <button type="button" className="kpi kpi--hero kpi--link" onClick={onClick}>
      <div className="kpi__label">{label}</div>
      <div className="kpi__hero-row">
        <div className="kpi__value" style={{ fontSize: 72 }}>
          {value}
        </div>
        {meta && <div className="kpi__hero-meta note">{meta}</div>}
      </div>
      {delta && (
        <div className="kpi__delta note" style={{ marginTop: 'auto' }}>
          {delta}
        </div>
      )}
      {hint && <span className="kpi__hint">{hint} →</span>}
    </button>
  );
}

KpiHero.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  meta: PropTypes.node,
  delta: PropTypes.node,
  hint: PropTypes.string,
  onClick: PropTypes.func,
};

// A regular KPI tile. Clickable when `onClick` is given.
export function Kpi({ label, value, onClick, hint }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      className={`kpi${onClick ? ' kpi--link' : ''}`}
      onClick={onClick}
    >
      <div className="kpi__label">{label}</div>
      <div className="kpi__value kpi__value--sm">{value}</div>
      {onClick && <span className="kpi__hint">{hint || 'Ver'} →</span>}
    </Tag>
  );
}

Kpi.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  hint: PropTypes.string,
};
